import React from 'react';
import styled from 'styled-components';
import UserCard from '../UserCard';
import { ICreatorFieldsFragment } from '../../utils/apollo/graphqlSchema';

interface IProps {
  creator: ICreatorFieldsFragment;
  label?: string;
  className?: string;
}

const Creator = styled(UserCard)`
  margin-top: 12px;
`;

export default ({ creator, label, className }: IProps) => (
  <Creator user={creator} size={'large'} label={label} className={className} />
);
